import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider as Provider } from 'styled-components';
import { getClientStyle } from '../../store/selectors/clientStyle';

const ThemeProvider = ({ children }) => {
    const clientStyle = useSelector(getClientStyle);

    return <Provider theme={clientStyle}>{children}</Provider>;
};

ThemeProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ThemeProvider;
